<template>
  <v-dialog
      :value="value"
      max-width="500"
      @click:outside="close"
  >
    <v-card>
      <v-card-title>
        営業者の承認依頼
      </v-card-title>
      <v-card-text>
        <v-select
            dense
            hide-details="auto"
            outlined
            label="営業者*"
            v-model="confirmer"
            :items="sellers"
            class="mb-4"
            :rules="[(v) => !!v || '営業者を選択してください。']"
            :item-value="item => item.email"
            no-data-text="該当データがありません。"
        >
          <template v-slot:selection="{item}">
            {{item.name}} {{ item.name ? '|' : null }} {{item.email}}
          </template>
          <template v-slot:item="{item}">
            {{item.name}} {{ item.name ? '|' : null }} {{item.email}}
          </template>
        </v-select>
        <v-textarea
            v-model="requestComment"
            label="コメント"
            outlined
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn @click="close" depressed>キャンセル</v-btn>
        <v-btn @click="sendRequest" color="primary" :disabled="!confirmer">依頼</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "RequestSellerConfirmationDialog",
  props: ['value', 'folderId', 'report'],
  data(){
    return {
      confirmer: '',
      requestComment: '',
      sellers: []
    }
  },
  methods: {
    close(){
      this.$emit('input');
    },
    sendRequest(){
      store.showLoadingOverlay(true)
      this.axios
          .post(`/api/report/request-confirmation/${this.folderId}`,
              {confirmer: this.confirmer,
                comment: this.requestComment.trim(),
                type: 'seller_confirm',
                updated_at: this.report.updated_at
              })
          .then((response) => {
            store.showSuccessDialog('相手に確認を依頼しました。');
            this.close();
            this.$emit('requested', response.data);
          })
          .catch((error) => {
            store.showErrorDialog(error.response.data.message);
            if (error.response.status === 403){
              this.$emit('updateOutdatedReport', error.response.data.report, error.response.data.report_pdf_pages);
            }
            this.$emit('input');
          })
          .then(() => {
            store.showLoadingOverlay(false);
          });
    },
    getSellers(){
      this.axios.get('/api/seller/').then((response) => {
        this.sellers = response.data;
      })
    }
  },
  created() {
    this.axios
        .get('/api/seller/' + this.folderId)
        .then((response) => {
          this.confirmer = response.data.seller;
        });
    this.getSellers();
  },
}
</script>

<style scoped>
>>>.v-label--is-disabled{
  color: rgba(0, 0, 0, 0.6);
}
>>>.v-input--is-disabled{
  color: rgba(0, 0, 0, 0.6);
}
</style>
